// ----------------------------------------------------------------------
// The ring that draws a control's boundary.
//
// A control whose resting state is *nothing selected* — a switch off-track and
// its knob, an unchecked box — is defined by its boundary rather than by its
// fill. A fill may be quiet; a boundary may not. The colour is
// `palette.controlEdge`, the role that exists for exactly this and is the only
// neutral on this ramp that clears the 3:1 a graphic owes on all three grounds
// the console draws on.
//
// It lives here rather than in the Switch override because it stopped being
// the Switch's for a while: `useBlockedAction` drew the same ring on the
// button it blocked, until a blocked button took the disabled look, the grey
// fill and no edge (2026-09-29). A shared value kept in one place is how a
// third consumer avoids re-typing `inset 0 0 0 1.25px` by hand.
//
// **A ring goes round the control and not round the control and its label.**
// `LabeledToggle` used to draw this around the whole pill, which made the word
// beside the switch read as a second control and left one ring doing two jobs
// — telling the pill from the card, and telling an operable pill from a
// withdrawn one. Those are a ground's job and a ground's job, and the pill
// takes `surfaceSunkenStrong` or nothing now. The switch inside kept its ring
// throughout, which is the point: the object is the switch.
//
// **1.25px, not 1px.** At 1px a ring on a 24px track disappears under the
// browser's own rounding at a non-integer device pixel ratio, which is the
// density most of this console is read at.
//
// Inset, so the ring costs the box nothing: a control is the same size in
// every state, and nothing beside it moves when the state changes.
// ----------------------------------------------------------------------

const EDGE = 1.25

export const controlEdgeRing = (color: string) =>
  `inset 0 0 0 ${EDGE}px ${color}`

export default controlEdgeRing
